import { MessageSquare, Sparkles } from "lucide-react";
import { useChatUI } from "@contexts/ChatContext";
import { useLocation } from "react-router-dom";

/**
 * Floating action button that opens the Gemini chat drawer.
 * Replaces the top-bar chat toggle. Fixed bottom-right on both
 * desktop and mobile; sits above the bottom nav on mobile.
 * On /design or /floorplans the secondary tab bar also appears,
 * so we bump the bottom offset a bit higher.
 */
export default function ChatFAB() {
  const { open, toggleChat } = useChatUI();
  const { pathname } = useLocation();

  if (open) return null;

  const hasSecondaryNav = pathname === "/design" || pathname === "/floorplans";

  return (
    <button
      onClick={toggleChat}
      className="fixed right-4 z-50 flex items-center gap-1.5 p-3 rounded-full shadow-lg transition-transform hover:scale-105 active:scale-95"
      style={{
        bottom: hasSecondaryNav
          ? "calc(var(--bottom-nav-h, 64px) + var(--secondary-nav-h, 44px) + 12px)"
          : "calc(var(--bottom-nav-h, 64px) + 12px)",
        background: "var(--ai-icon)",
        border: "1px solid rgba(139, 92, 246, 0.5)",
      }}
      aria-label="Open AI assistant"
      title="Open AI assistant"
    >
      <Sparkles className="w-4 h-4 text-white" />
      <MessageSquare className="w-4 h-4 text-white" />
    </button>
  );
}
